(function () {
  'use strict';
  var toggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var shouldOpen = mobileNav.hasAttribute('hidden');
      if (shouldOpen) { mobileNav.removeAttribute('hidden'); }
      else { mobileNav.setAttribute('hidden', ''); }
      toggle.setAttribute('aria-expanded', String(shouldOpen));
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !mobileNav.hasAttribute('hidden')) {
        mobileNav.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }
  document.querySelectorAll('[data-auto-submit]').forEach(function (select) {
    select.addEventListener('change', function () { select.form.requestSubmit ? select.form.requestSubmit() : select.form.submit(); });
  });
  document.querySelectorAll('[data-il-variant-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var price = select.closest('.il-product-detail').querySelector('[data-product-price]');
      var chosen = select.options[select.selectedIndex];
      if (price && chosen) { price.textContent = chosen.dataset.displayPrice || price.textContent; }
    });
  });
})();
